module.exports = __webpack_public_path__ + "img/card_background.bebd7c16.png";